import { gql } from '@apollo/client'
import { imageData, userDataCompressed } from '../../../common/fragments'

export const GET_DEAL_NOTES = gql`
	query getDealNotes(
		$deal_id: ID
		$thumbnailResolution: String = "128x128"
	) {
		getDealNotes(input: { deal_id: $deal_id }) {
			id
			type_id
			applied_at
			applied_user_id
			note_text
			is_critical
			is_private
			is_deleted
			created_by
			created_at
			modified_by
			modified_at
			user {
				...userDataCompressed
				is_deleted
			}
			images {
				...imageData
			}
		}
	}
	${imageData}
	${userDataCompressed}
`

export const CREATE_NOTE = gql`
	mutation createDealNote(
		$CreateNoteInput: CreateNoteInput!
		$thumbnailResolution: String = "128x128"
	) {
		createDealNote(input: $CreateNoteInput) {
			code
			success
			message
			note {
				id
				type_id
				applied_at
				applied_user_id
				note_text
				created_by
				created_at
				modified_by
				modified_at
				is_critical
				is_private
				is_deleted
				user {
					...userDataCompressed
					is_deleted
				}
				images {
					...imageData
				}
			}
		}
	}
	${imageData}
	${userDataCompressed}
`


export const DEAL_UPDATE_NOTE = gql`
	mutation updateDealNote(
		$UpdateNoteInput: UpdateNoteInput!
		$thumbnailResolution: String = "128x128"
	) {
		updateDealNote(input: $UpdateNoteInput) {
			code
			success
			message
			note {
				id
				type_id
				applied_at
				applied_user_id
				note_text
				is_critical
				is_private
				is_deleted
				created_by
				created_at
				modified_by
				modified_at
				user {
					...userDataCompressed
					is_deleted
				}
				images {
					...imageData
				}
			}
		}
	}
	${imageData}
	${userDataCompressed}
`
